import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import './Style.scss'

const TextRightImage = ({ articleObj }) => {
  var content = articleObj;
  return (
    <>
      <div className={`${content.attributes.articleRendering}      ${content.attributes.class}`} data-type="TextRightImage"
        style={content.attributes.articlePadding ? { padding: `${content.attributes.articleContainerPadding}` } : {}}	>
        <div className='card-design d-flex'>
          
          {content.title ?
            <p className='card-text' dangerouslySetInnerHTML={{ __html: content.title }}></p>
            : ""}
          {content.body ?
            <div className='card-body' dangerouslySetInnerHTML={{ __html: content.body }}></div>
            : ""}
            {content.attributes.mainImageUrl ?
            <Link target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""}
              to={content.attributes.mainImageUrl}>
              <img fetchpriority="high" src={`${content.mainImage ? content.mainImage : ""}`} className='img-fluid' alt={content.attributes.altText} />
            </Link>
            :
            <img fetchpriority="high" src={`${content.mainImage ? content.mainImage : ""}`} className={`img-fluid ${content.attributes.imageRendering}`} alt={content.attributes.altText} />
          }
        </div>
      </div>
    </>
  )
}

export default TextRightImage